// // src/pages/StudentTrainingHistory/StudentTrainingHistory.jsx
// import React, { useEffect, useState, useMemo } from "react";
// import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap";
// import { connect } from "react-redux";
// import { setBreadcrumbItems } from "../../store/actions";
// import Loader from "components/Loader/Loader";
// import { toast } from "react-toastify";
// import {
//   getHistoriesWithFilters,
//   getFilterValues,
//   getAutoGenerationStatus,
//   deleteHistory,
//   deleteStudentHistory,
//   generateBatchHistory,
//   exportHistoryExcel,
// } from "helpers/student_training_history_helper";
// import {
//   Paper,
//   TextField,
//   Grid,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Typography,
//   Box,
//   Chip,
//   CircularProgress,
//   Alert,
//   AlertTitle,
//   IconButton,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TablePagination,
//   TableSortLabel,
//   Tooltip,
//   Collapse,
// } from "@mui/material";
// import {
//   Close as CloseIcon,
//   FilterList as FilterIcon,
//   Clear as ClearIcon,
//   School as SchoolIcon,
//   CheckCircle as CheckCircleIcon,
//   Cancel as CancelIcon,
//   Pending as PendingIcon,
//   Refresh as RefreshIcon,
//   Visibility as VisibilityIcon,
//   Delete as DeleteIcon,
//   GridOn as ExcelIcon,
// } from "@mui/icons-material";

// const StudentTrainingHistory = (props) => {
//   document.title = "Question System | Student Training History";
  
//   const { setBreadcrumbItems } = props;

//   // ============================
//   // GET ORGANIZATION ID - SAME AS AllGroup.js
//   // ============================
//   const getOrganizationId = () => {
//     try {
//       // Get from localStorage (same as AllGroup.js)
//       const authUser = JSON.parse(localStorage.getItem("authUser"));
//       if (authUser?.organizationId) {
//         console.log("✅ Found organizationId from localStorage:", authUser.organizationId);
//         return authUser.organizationId;
//       }
//       if (authUser?.organization?.id) {
//         console.log("✅ Found organization.id from localStorage:", authUser.organization.id);
//         return authUser.organization.id;
//       }
      
//       // Try Redux state
//       if (props.auth?.user?.organizationId) {
//         console.log("✅ Found organizationId from Redux:", props.auth.user.organizationId);
//         return props.auth.user.organizationId;
//       }
//       if (props.auth?.user?.organization?.id) {
//         console.log("✅ Found organization.id from Redux:", props.auth.user.organization.id);
//         return props.auth.user.organization.id;
//       }
//       if (props.auth?.organizationId) {
//         console.log("✅ Found organizationId from Redux auth:", props.auth.organizationId);
//         return props.auth.organizationId;
//       }
      
//       // Default to 2 (Tata Motors)
//       console.log("⚠️ No organization ID found, using default: 2");
//       return 2;
//     } catch (error) {
//       console.error("Error getting organization ID:", error);
//       return 2;
//     }
//   };

//   // ============================
//   // STATE
//   // ============================
//   const [loader, setLoader] = useState(false);
//   const [histories, setHistories] = useState([]);
//   const [filteredHistories, setFilteredHistories] = useState([]);
//   const [totalRecords, setTotalRecords] = useState(0);
//   const [totalPages, setTotalPages] = useState(0);
//   const [currentPage, setCurrentPage] = useState(0);
//   const [pageSize, setPageSize] = useState(10);
//   const [error, setError] = useState(null);
  
//   // Get organization ID on component mount
//   const [organizationId, setOrganizationId] = useState(getOrganizationId());
  
//   // Filter State
//   const [filters, setFilters] = useState({
//     organizationId: getOrganizationId(),
//     state: "",
//     depot: "",
//     courseName: "",
//     failPass: "",
//     searchKeyword: "",
//   });
  
//   const [filterValues, setFilterValues] = useState({
//     states: [],
//     depots: [],
//     courseNames: [],
//     failPassStatuses: [],
//   });
  
//   const [showFilters, setShowFilters] = useState(true);
//   const [detailDialogOpen, setDetailDialogOpen] = useState(false);
//   const [selectedDetail, setSelectedDetail] = useState(null);
//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [selectedHistory, setSelectedHistory] = useState(null);
//   const [exportLoading, setExportLoading] = useState(false);
//   const [generateLoading, setGenerateLoading] = useState(false);
  
//   // Sorting
//   const [sortBy, setSortBy] = useState("trainingEndDate");
//   const [sortDirection, setSortDirection] = useState("DESC");

//   // ============================
//   // EFFECTS
//   // ============================
  
//   // Breadcrumb
//   useEffect(() => {
//     const breadcrumbItems = [
//       { title: "Training Management", link: "#" },
//       { title: "Student Training History", link: "#" },
//     ];
//     setBreadcrumbItems("Student Training History", breadcrumbItems);
//   }, [setBreadcrumbItems]);

//   // Load data on mount
//   useEffect(() => {
//     const orgId = getOrganizationId();
//     console.log("🚀 Initial organization ID:", orgId);
//     setOrganizationId(orgId);
//     setFilters(prev => ({ ...prev, organizationId: orgId }));
//     loadInitialData(orgId);
//   }, []);

//   // Load histories when filters or pagination changes
//   useEffect(() => {
//     if (filters.organizationId && !loader) {
//       fetchHistories();
//     }
//   }, [filters, currentPage, pageSize, sortBy, sortDirection]);

//   // ============================
//   // API FUNCTIONS
//   // ============================
  
//   const loadInitialData = async (orgId) => {
//     try {
//       setLoader(true);
//       setError(null);
      
//       console.log("🚀 Loading initial data for organization:", orgId);
      
//       // Load filter values first
//       await loadFilterValues(orgId);
      
//       // Then load histories
//       await fetchHistories();
      
//     } catch (error) {
//       console.error("❌ Error loading initial data:", error);
//       setError("Failed to load data. Please refresh the page.");
//       toast.error("Failed to load data. Please refresh the page.");
//     } finally {
//       setLoader(false);
//     }
//   };

//   const loadFilterValues = async (orgId) => {
//     try {
//       console.log("📥 Fetching filter values for org:", orgId);
//       const response = await getFilterValues(orgId);
//       console.log("📥 Filter values response:", response);
      
//       if (response?.success) {
//         setFilterValues({
//           states: response.states || [],
//           depots: response.depots || [],
//           courseNames: response.courseNames || [],
//           failPassStatuses: response.failPassStatuses || [],
//         });
//         console.log("✅ Filter values loaded for organization:", orgId);
//       } else {
//         // Use default values
//         setFilterValues({
//           states: ["Maharashtra", "Gujarat", "Tamil Nadu", "Karnataka"],
//           depots: ["Depot A", "Depot B", "Depot C"],
//           courseNames: ["Suraksha", "BBS", "ESH", "Simulator"],
//           failPassStatuses: ["Pass", "Fail", "Not Attempted", "Pending"],
//         });
//         console.warn("⚠️ Using default filter values");
//       }
//     } catch (error) {
//       console.error("❌ Error loading filter values:", error);
//       // Set default values
//       setFilterValues({
//         states: ["Maharashtra", "Gujarat", "Tamil Nadu", "Karnataka"],
//         depots: ["Depot A", "Depot B", "Depot C"],
//         courseNames: ["Suraksha", "BBS", "ESH", "Simulator"],
//         failPassStatuses: ["Pass", "Fail", "Not Attempted", "Pending"],
//       });
//     }
//   };

//   const fetchHistories = async () => {
//     try {
//       setLoader(true);
//       setError(null);
      
//       // Always use the current organization ID
//       const currentOrgId = filters.organizationId || organizationId || getOrganizationId();
      
//       const params = {
//         ...filters,
//         organizationId: currentOrgId,
//         page: currentPage,
//         size: pageSize,
//         sortBy: sortBy,
//         sortDirection: sortDirection,
//       };
      
//       console.log("📤 Fetching histories with params:", params);
      
//       const response = await getHistoriesWithFilters(params);
      
//       console.log("📥 Histories response:", response);
      
//       if (response?.success) {
//         const data = response.data || [];
//         setHistories(data);
//         setFilteredHistories(data);
//         setTotalRecords(response.totalRecords || data.length);
//         setTotalPages(response.totalPages || 0);
//         setCurrentPage(response.currentPage || 0);
//         console.log(`✅ Loaded ${data.length} records for organization ${currentOrgId}`);
        
//         if (data.length === 0) {
//           toast.info(`No records found for organization ${currentOrgId}`);
//         }
//       } else {
//         setError(response?.message || "Failed to fetch histories");
//         toast.error(response?.message || "Failed to fetch histories");
//       }
//     } catch (error) {
//       console.error("❌ Error fetching histories:", error);
//       setError("Failed to load training histories. Please try again.");
//       toast.error("Failed to load training histories");
//     } finally {
//       setLoader(false);
//     }
//   };

//   // ============================
//   // HANDLER FUNCTIONS
//   // ============================
  
//   const handleFilterChange = (field, value) => {
//     setFilters(prev => ({ ...prev, [field]: value }));
//     setCurrentPage(0);
//   };

//   const handleClearFilters = () => {
//     setFilters({
//       ...filters,
//       state: "",
//       depot: "",
//       courseName: "",
//       failPass: "",
//       searchKeyword: "",
//     });
//     setCurrentPage(0);
//   };

//   const handlePageChange = (event, newPage) => {
//     setCurrentPage(newPage);
//   };

//   const handlePageSizeChange = (event) => {
//     setPageSize(parseInt(event.target.value, 10));
//     setCurrentPage(0);
//   };

//   const handleSort = (field) => {
//     const isAsc = sortBy === field && sortDirection === "ASC";
//     setSortDirection(isAsc ? "DESC" : "ASC");
//     setSortBy(field);
//   };

//   const handleViewDetail = (history) => {
//     setSelectedDetail(history);
//     setDetailDialogOpen(true);
//   };

//   const handleRefresh = () => {
//     fetchHistories();
//   };

//   const handleDeleteHistory = async () => {
//     if (!selectedHistory) return;
    
//     try {
//       setLoader(true);
//       const response = await deleteHistory(selectedHistory.id);
      
//       if (response?.success) {
//         toast.success("History deleted successfully");
//         setDeleteDialogOpen(false);
//         setSelectedHistory(null);
//         fetchHistories();
//       } else {
//         toast.error(response?.message || "Failed to delete history");
//       }
//     } catch (error) {
//       console.error("Error deleting history:", error);
//       toast.error("Failed to delete history");
//     } finally {
//       setLoader(false);
//     }
//   };

//   const handleDeleteAllForStudent = async (studentId) => {
//     if (!studentId) return;
    
//     if (!window.confirm("Are you sure you want to delete all histories for this student?")) {
//       return;
//     }
    
//     try {
//       setLoader(true);
//       const response = await deleteStudentHistory(studentId);
      
//       if (response?.success) {
//         toast.success("All histories deleted for student");
//         fetchHistories();
//       } else {
//         toast.error(response?.message || "Failed to delete histories");
//       }
//     } catch (error) {
//       console.error("Error deleting histories:", error);
//       toast.error("Failed to delete histories");
//     } finally {
//       setLoader(false);
//     }
//   };

//   const handleExportExcel = async () => {
//     try {
//       setExportLoading(true);
      
//       const params = {
//         ...filters,
//         sortBy: sortBy,
//         sortDirection: sortDirection,
//       };
      
//       const response = await exportHistoryExcel(params);
      
//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", `student_training_history_${new Date().toISOString().split('T')[0]}.xlsx`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
      
//       toast.success("Export completed successfully");
//     } catch (error) {
//       console.error("Error exporting:", error);
//       toast.error("Failed to export data");
//     } finally {
//       setExportLoading(false);
//     }
//   };

//   // ============================
//   // UI HELPER FUNCTIONS
//   // ============================
  
//   const getStatusChip = (status) => {
//     if (!status) return <Chip label="N/A" size="small" variant="outlined" />;
    
//     const statusLower = status.toLowerCase();
//     if (statusLower.includes("pass")) {
//       return <Chip label="Pass" color="success" size="small" icon={<CheckCircleIcon />} />;
//     } else if (statusLower.includes("fail")) {
//       return <Chip label="Fail" color="error" size="small" icon={<CancelIcon />} />;
//     } else if (statusLower.includes("pending") || statusLower.includes("not attempted")) {
//       return <Chip label="Pending" color="warning" size="small" icon={<PendingIcon />} />;
//     }
//     return <Chip label={status} size="small" variant="outlined" />;
//   };

//   const getProgressColor = (progress) => {
//     if (!progress) return "default";
//     const num = parseInt(progress);
//     if (num >= 80) return "success";
//     if (num >= 50) return "warning";
//     return "error";
//   };

//   // ============================
//   // COLUMNS
//   // ============================
  
//   const columns = [
//     { id: "serialNo", label: "S.No.", minWidth: 60, sortable: true },
//     { id: "employeeId", label: "Employee Id", minWidth: 100, sortable: true },
//     { id: "participantName", label: "Participant Name", minWidth: 150, sortable: true },
//     { id: "fatherName", label: "Father Name", minWidth: 120, sortable: true },
//     { id: "courseName", label: "Course Name", minWidth: 150, sortable: true },
//     { id: "preTest", label: "Pre Test", minWidth: 80, sortable: true },
//     { id: "postTest", label: "Post Test", minWidth: 80, sortable: true },
//     { id: "practicalGrade", label: "Practical Grade", minWidth: 100, sortable: true },
//     { id: "failPass", label: "Fail/Pass", minWidth: 100, sortable: true },
//     { id: "remarks", label: "Remarks", minWidth: 120, sortable: false },
//     { id: "actions", label: "Actions", minWidth: 120, sortable: false },
//   ];

//   // ============================
//   // RENDER
//   // ============================
  
//   return (
//     <React.Fragment>
//       {loader && <Loader />}
      
//       <Row>
//         <Col className="col-12">
//           <Card>
//             <CardBody>
//               <CardTitle className="h4">
//                 <SchoolIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
//                 Student Training History
//                 <div className="float-end" style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
//                   <Button
//                     color="primary"
//                     onClick={() => setShowFilters(!showFilters)}
//                     style={{ display: "flex", alignItems: "center", gap: "5px" }}
//                   >
//                     <FilterIcon /> {showFilters ? "Hide Filters" : "Show Filters"}
//                   </Button>
//                   <Button
//                     color="success"
//                     onClick={handleExportExcel}
//                     disabled={exportLoading || filteredHistories.length === 0}
//                   >
//                     {exportLoading ? (
//                       <>
//                         <CircularProgress size={16} color="inherit" /> Exporting...
//                       </>
//                     ) : (
//                       <>
//                         <ExcelIcon /> Export
//                       </>
//                     )}
//                   </Button>
//                   <Button
//                     color="info"
//                     onClick={handleRefresh}
//                     disabled={loader}
//                   >
//                     <RefreshIcon /> Refresh
//                   </Button>
//                 </div>
//               </CardTitle>

//               {/* Organization Info - Same as AllGroup.js style */}
//               <Alert severity="info" sx={{ mb: 2 }}>
//                 <AlertTitle>Organization Information</AlertTitle>
//                 <Typography variant="body2">
//                   Currently viewing data for Organization ID: <strong>{filters.organizationId || organizationId}</strong>
//                 </Typography>
//                 <Typography variant="caption" color="textSecondary">
//                   This organization ID is fetched from your logged-in user account.
//                 </Typography>
//               </Alert>

//               {/* Error Alert */}
//               {error && (
//                 <Alert severity="error" sx={{ mb: 3 }}>
//                   <AlertTitle>Error</AlertTitle>
//                   {error}
//                   <Button 
//                     color="primary" 
//                     size="sm" 
//                     onClick={handleRefresh}
//                     style={{ marginTop: '10px' }}
//                   >
//                     Retry
//                   </Button>
//                 </Alert>
//               )}

//               {/* Filter Section */}
//               <Collapse in={showFilters}>
//                 <Paper elevation={2} sx={{ p: 3, mb: 3, mt: 2 }}>
//                   <Grid container spacing={2} alignItems="center">
//                     <Grid item xs={12}>
//                       <Box display="flex" justifyContent="space-between" alignItems="center">
//                         <Typography variant="h6" gutterBottom>
//                           Filters
//                         </Typography>
//                         <IconButton size="small" onClick={handleClearFilters} sx={{ ml: 1 }}>
//                           <ClearIcon />
//                         </IconButton>
//                       </Box>
//                     </Grid>
                    
//                     <Grid item xs={12} md={4}>
//                       <TextField
//                         fullWidth
//                         size="small"
//                         label="Search Keyword"
//                         value={filters.searchKeyword}
//                         onChange={(e) => handleFilterChange("searchKeyword", e.target.value)}
//                         placeholder="Search by name, phone, aadhaar, emp ID, course..."
//                         onKeyPress={(e) => {
//                           if (e.key === 'Enter') {
//                             fetchHistories();
//                           }
//                         }}
//                       />
//                     </Grid>
                    
//                     <Grid item xs={12} md={2}>
//                       <FormControl fullWidth size="small">
//                         <InputLabel>State</InputLabel>
//                         <Select
//                           value={filters.state}
//                           label="State"
//                           onChange={(e) => handleFilterChange("state", e.target.value)}
//                         >
//                           <MenuItem value="">All States</MenuItem>
//                           {filterValues.states.map((state) => (
//                             <MenuItem key={state} value={state}>{state}</MenuItem>
//                           ))}
//                         </Select>
//                       </FormControl>
//                     </Grid>
                    
//                     <Grid item xs={12} md={2}>
//                       <FormControl fullWidth size="small">
//                         <InputLabel>Depot</InputLabel>
//                         <Select
//                           value={filters.depot}
//                           label="Depot"
//                           onChange={(e) => handleFilterChange("depot", e.target.value)}
//                         >
//                           <MenuItem value="">All Depots</MenuItem>
//                           {filterValues.depots.map((depot) => (
//                             <MenuItem key={depot} value={depot}>{depot}</MenuItem>
//                           ))}
//                         </Select>
//                       </FormControl>
//                     </Grid>
                    
//                     <Grid item xs={12} md={2}>
//                       <FormControl fullWidth size="small">
//                         <InputLabel>Course</InputLabel>
//                         <Select
//                           value={filters.courseName}
//                           label="Course"
//                           onChange={(e) => handleFilterChange("courseName", e.target.value)}
//                         >
//                           <MenuItem value="">All Courses</MenuItem>
//                           {filterValues.courseNames.map((course) => (
//                             <MenuItem key={course} value={course}>{course}</MenuItem>
//                           ))}
//                         </Select>
//                       </FormControl>
//                     </Grid>
                    
//                     <Grid item xs={12} md={2}>
//                       <FormControl fullWidth size="small">
//                         <InputLabel>Status</InputLabel>
//                         <Select
//                           value={filters.failPass}
//                           label="Status"
//                           onChange={(e) => handleFilterChange("failPass", e.target.value)}
//                         >
//                           <MenuItem value="">All Statuses</MenuItem>
//                           {filterValues.failPassStatuses.map((status) => (
//                             <MenuItem key={status} value={status}>{status}</MenuItem>
//                           ))}
//                         </Select>
//                       </FormControl>
//                     </Grid>
                    
//                     <Grid item xs={12}>
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         onClick={fetchHistories}
//                         disabled={loader}
//                       >
//                         {loader ? <CircularProgress size={20} /> : "Apply Filters"}
//                       </Button>
//                     </Grid>
//                   </Grid>
//                 </Paper>
//               </Collapse>

//               {/* Statistics Summary */}
//               <Paper elevation={2} sx={{ p: 2, mb: 3 }}>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12} sm={3}>
//                     <Box sx={{ textAlign: "center", p: 1 }}>
//                       <Typography variant="h4" color="primary">
//                         {totalRecords}
//                       </Typography>
//                       <Typography variant="body2" color="textSecondary">
//                         Total Records
//                       </Typography>
//                     </Box>
//                   </Grid>
//                   <Grid item xs={12} sm={3}>
//                     <Box sx={{ textAlign: "center", p: 1 }}>
//                       <Typography variant="h4" color="success.main">
//                         {filteredHistories.filter(h => h.failPass?.toLowerCase().includes("pass")).length}
//                       </Typography>
//                       <Typography variant="body2" color="textSecondary">
//                         Pass
//                       </Typography>
//                     </Box>
//                   </Grid>
//                   <Grid item xs={12} sm={3}>
//                     <Box sx={{ textAlign: "center", p: 1 }}>
//                       <Typography variant="h4" color="error.main">
//                         {filteredHistories.filter(h => h.failPass?.toLowerCase().includes("fail")).length}
//                       </Typography>
//                       <Typography variant="body2" color="textSecondary">
//                         Fail
//                       </Typography>
//                     </Box>
//                   </Grid>
//                   <Grid item xs={12} sm={3}>
//                     <Box sx={{ textAlign: "center", p: 1 }}>
//                       <Typography variant="h4" color="warning.main">
//                         {filteredHistories.filter(h => 
//                           h.failPass?.toLowerCase().includes("pending") || 
//                           h.failPass?.toLowerCase().includes("not attempted")
//                         ).length}
//                       </Typography>
//                       <Typography variant="body2" color="textSecondary">
//                         Pending
//                       </Typography>
//                     </Box>
//                   </Grid>
//                 </Grid>
//               </Paper>

//               {/* History Table */}
//               <Paper sx={{ width: "100%", overflow: "hidden" }}>
//                 <TableContainer sx={{ maxHeight: 600 }}>
//                   <Table stickyHeader size="small">
//                     <TableHead>
//                       <TableRow>
//                         {columns.map((column) => (
//                           <TableCell
//                             key={column.id}
//                             style={{ minWidth: column.minWidth, fontWeight: "bold", backgroundColor: "#f5f5f5" }}
//                           >
//                             {column.sortable ? (
//                               <TableSortLabel
//                                 active={sortBy === column.id}
//                                 direction={sortBy === column.id ? sortDirection.toLowerCase() : "asc"}
//                                 onClick={() => handleSort(column.id)}
//                               >
//                                 {column.label}
//                               </TableSortLabel>
//                             ) : (
//                               column.label
//                             )}
//                           </TableCell>
//                         ))}
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {filteredHistories.length === 0 ? (
//                         <TableRow>
//                           <TableCell colSpan={columns.length} align="center">
//                             <Typography variant="body1" sx={{ py: 3 }}>
//                               {loader ? "Loading..." : `No training history records found for organization ${filters.organizationId}`}
//                             </Typography>
//                           </TableCell>
//                         </TableRow>
//                       ) : (
//                         filteredHistories.map((history, index) => {
//                           const isFirstRow = index === 0 || 
//                             filteredHistories[index - 1]?.studentId !== history.studentId;
                          
//                           const studentRowCount = filteredHistories.filter(
//                             h => h.studentId === history.studentId
//                           ).length;
                          
//                           return (
//                             <TableRow key={history.id} hover>
//                               {isFirstRow ? (
//                                 <TableCell rowSpan={studentRowCount}>
//                                   <Typography variant="body2" fontWeight="bold">
//                                     {history.serialNo || index + 1}
//                                   </Typography>
//                                 </TableCell>
//                               ) : null}
                              
//                               {isFirstRow ? (
//                                 <TableCell rowSpan={studentRowCount}>
//                                   {history.employeeId || "N/A"}
//                                 </TableCell>
//                               ) : null}
                              
//                               {isFirstRow ? (
//                                 <TableCell rowSpan={studentRowCount}>
//                                   <Typography variant="body2" fontWeight="bold">
//                                     {history.participantName || "N/A"}
//                                   </Typography>
//                                 </TableCell>
//                               ) : null}
                              
//                               {isFirstRow ? (
//                                 <TableCell rowSpan={studentRowCount}>
//                                   {history.fatherName || "N/A"}
//                                 </TableCell>
//                               ) : null}
                              
//                               <TableCell>
//                                 <Tooltip title={history.courseName}>
//                                   <Typography variant="body2" noWrap sx={{ maxWidth: 140 }}>
//                                     {history.courseName || "N/A"}
//                                   </Typography>
//                                 </Tooltip>
//                               </TableCell>
//                               <TableCell>
//                                 <Chip
//                                   label={history.preTest || "0%"}
//                                   size="small"
//                                   color={getProgressColor(history.preTest)}
//                                 />
//                               </TableCell>
//                               <TableCell>
//                                 <Chip
//                                   label={history.postTest || "0%"}
//                                   size="small"
//                                   color={getProgressColor(history.postTest)}
//                                 />
//                               </TableCell>
//                               <TableCell>
//                                 <Chip
//                                   label={history.practicalGrade || "N/A"}
//                                   size="small"
//                                   variant="outlined"
//                                 />
//                               </TableCell>
//                               <TableCell>{getStatusChip(history.failPass)}</TableCell>
//                               <TableCell>
//                                 <Typography variant="body2" noWrap sx={{ maxWidth: 100 }}>
//                                   {history.remarks || "N/A"}
//                                 </Typography>
//                               </TableCell>
                              
//                               {isFirstRow ? (
//                                 <TableCell rowSpan={studentRowCount}>
//                                   <Box display="flex" flexDirection="column" gap={0.5}>
//                                     <Tooltip title="View Details">
//                                       <IconButton
//                                         size="small"
//                                         color="primary"
//                                         onClick={() => handleViewDetail(history)}
//                                       >
//                                         <VisibilityIcon fontSize="small" />
//                                       </IconButton>
//                                     </Tooltip>
//                                     <Tooltip title="Delete All for Student">
//                                       <IconButton
//                                         size="small"
//                                         color="error"
//                                         onClick={() => {
//                                           if (window.confirm(`Delete all histories for ${history.participantName}?`)) {
//                                             handleDeleteAllForStudent(history.studentId);
//                                           }
//                                         }}
//                                       >
//                                         <DeleteIcon fontSize="small" />
//                                       </IconButton>
//                                     </Tooltip>
//                                   </Box>
//                                 </TableCell>
//                               ) : null}
//                             </TableRow>
//                           );
//                         })
//                       )}
//                     </TableBody>
//                   </Table>
//                 </TableContainer>
                
//                 <TablePagination
//                   rowsPerPageOptions={[10, 25, 50, 100]}
//                   component="div"
//                   count={totalRecords}
//                   rowsPerPage={pageSize}
//                   page={currentPage}
//                   onPageChange={handlePageChange}
//                   onRowsPerPageChange={handlePageSizeChange}
//                 />
//               </Paper>
//             </CardBody>
//           </Card>
//         </Col>
//       </Row>

//       {/* Detail View Dialog */}
//       <Dialog
//         open={detailDialogOpen}
//         onClose={() => setDetailDialogOpen(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>
//           <Box display="flex" justifyContent="space-between" alignItems="center">
//             <Typography variant="h6">Training History Details</Typography>
//             <IconButton onClick={() => setDetailDialogOpen(false)}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent dividers>
//           {selectedDetail && (
//             <Grid container spacing={2}>
//               <Grid item xs={12}>
//                 <Typography variant="subtitle1" color="primary" gutterBottom>
//                   Candidate Information
//                 </Typography>
//                 <Paper variant="outlined" sx={{ p: 2 }}>
//                   <Grid container spacing={1}>
//                     <Grid item xs={6}>
//                       <Typography variant="body2"><strong>Name:</strong> {selectedDetail.participantName || "N/A"}</Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                       <Typography variant="body2"><strong>Employee ID:</strong> {selectedDetail.employeeId || "N/A"}</Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                       <Typography variant="body2"><strong>Father Name:</strong> {selectedDetail.fatherName || "N/A"}</Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                       <Typography variant="body2"><strong>Phone:</strong> {selectedDetail.phoneNumber || "N/A"}</Typography>
//                     </Grid>
//                   </Grid>
//                 </Paper>
//               </Grid>

//               <Grid item xs={12}>
//                 <Typography variant="subtitle1" color="primary" gutterBottom>
//                   Training Details
//                 </Typography>
//                 <Paper variant="outlined" sx={{ p: 2 }}>
//                   <Grid container spacing={1}>
//                     <Grid item xs={6}>
//                       <Typography variant="body2"><strong>Course:</strong> {selectedDetail.courseName || "N/A"}</Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                       <Typography variant="body2"><strong>Depot:</strong> {selectedDetail.depot || "N/A"}</Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                       <Typography variant="body2"><strong>State:</strong> {selectedDetail.state || "N/A"}</Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                       <Typography variant="body2"><strong>Training Mode:</strong> {selectedDetail.trainingMode || "N/A"}</Typography>
//                     </Grid>
//                   </Grid>
//                 </Paper>
//               </Grid>

//               <Grid item xs={12}>
//                 <Typography variant="subtitle1" color="primary" gutterBottom>
//                   Results
//                 </Typography>
//                 <Paper variant="outlined" sx={{ p: 2 }}>
//                   <Grid container spacing={1}>
//                     <Grid item xs={4}>
//                       <Typography variant="body2"><strong>Pre Test:</strong> {selectedDetail.preTest || "0%"}</Typography>
//                     </Grid>
//                     <Grid item xs={4}>
//                       <Typography variant="body2"><strong>Post Test:</strong> {selectedDetail.postTest || "0%"}</Typography>
//                     </Grid>
//                     <Grid item xs={4}>
//                       <Typography variant="body2"><strong>Practical Grade:</strong> {selectedDetail.practicalGrade || "N/A"}</Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                       <Typography variant="body2"><strong>Status:</strong> {getStatusChip(selectedDetail.failPass)}</Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                       <Typography variant="body2"><strong>Remarks:</strong> {selectedDetail.remarks || "N/A"}</Typography>
//                     </Grid>
//                   </Grid>
//                 </Paper>
//               </Grid>
//             </Grid>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDetailDialogOpen(false)} color="secondary">
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Delete Confirmation Dialog */}
//       <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
//         <DialogTitle>Confirm Delete</DialogTitle>
//         <DialogContent>
//           <Typography>
//             Are you sure you want to delete this training history?
//           </Typography>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDeleteDialogOpen(false)} color="secondary">
//             Cancel
//           </Button>
//           <Button onClick={handleDeleteHistory} color="error">
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </React.Fragment>
//   );
// };

// // ============================
// // MAP STATE TO PROPS - SAME AS AllGroup.js style
// // ============================
// const mapStateToProps = (state) => {
//   return {
//     auth: state.auth || state.login || state,
//   };
// };

// export default connect(mapStateToProps, { setBreadcrumbItems })(StudentTrainingHistory);











// // src/pages/StudentTrainingHistory/StudentTrainingHistory.jsx
// import React, { useEffect, useState, useMemo } from "react";
// import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap";
// import { connect } from "react-redux";
// import { setBreadcrumbItems } from "../../store/actions";
// import Loader from "components/Loader/Loader";
// import { toast } from "react-toastify";
// import {
//   getHistoriesWithFilters,
//   getFilterValues,
//   getAutoGenerationStatus,
//   deleteHistory,
//   deleteStudentHistory,
//   generateBatchHistory,
//   exportHistoryExcel,
// } from "helpers/student_training_history_helper";
// import {
//   generateSdrReport,
//   generateNeverEnrolledReport,
//   getSdrStates,
//   getSdrDepots,
//   getSdrCourses,
// } from "helpers/sdr_report_helper";
// import {
//   Paper,
//   TextField,
//   Grid,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Typography,
//   Box,
//   Chip,
//   CircularProgress,
//   Alert,
//   AlertTitle,
//   IconButton,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TablePagination,
//   TableSortLabel,
//   Tooltip,
//   Collapse,
//   ToggleButton,
//   ToggleButtonGroup,
//   InputAdornment,
// } from "@mui/material";
// import {
//   Close as CloseIcon,
//   FilterList as FilterIcon,
//   Clear as ClearIcon,
//   School as SchoolIcon,
//   CheckCircle as CheckCircleIcon,
//   Cancel as CancelIcon,
//   Pending as PendingIcon,
//   Refresh as RefreshIcon,
//   Visibility as VisibilityIcon,
//   Delete as DeleteIcon,
//   GridOn as ExcelIcon,
//   Download as DownloadIcon,
//   People as PeopleIcon,
//   PersonOff as PersonOffIcon,
//   Info as InfoIcon,
//   Search as SearchIcon,
// } from "@mui/icons-material";
// import { useNavigate } from "react-router-dom";

// const StudentTrainingHistory = (props) => {
//   document.title = "Question System | Student Training History";
  
//   const navigate = useNavigate();
//   const { setBreadcrumbItems } = props;

//   // ============================
//   // GET ORGANIZATION ID
//   // ============================
//   const getOrganizationId = () => {
//     try {
//       const authUser = JSON.parse(localStorage.getItem("authUser"));
//       if (authUser?.organizationId) return authUser.organizationId;
//       if (authUser?.organization?.id) return authUser.organization.id;
//       if (props.auth?.user?.organizationId) return props.auth.user.organizationId;
//       if (props.auth?.organizationId) return props.auth.organizationId;
//       return 2;
//     } catch (error) {
//       return 2;
//     }
//   };

//   // ============================
//   // STATE
//   // ============================
//   const [loader, setLoader] = useState(false);
//   const [histories, setHistories] = useState([]);
//   const [filteredHistories, setFilteredHistories] = useState([]);
//   const [totalRecords, setTotalRecords] = useState(0);
//   const [totalPages, setTotalPages] = useState(0);
//   const [currentPage, setCurrentPage] = useState(0);
//   const [pageSize, setPageSize] = useState(10);
//   const [error, setError] = useState(null);
  
//   const [organizationId, setOrganizationId] = useState(getOrganizationId());
  
//   // Report Modal State
//   const [reportModalOpen, setReportModalOpen] = useState(false);
//   const [reportType, setReportType] = useState("all");
//   const [reportLoading, setReportLoading] = useState(false);
//   const [reportFilters, setReportFilters] = useState({
//     batchId: "",
//     state: "",
//     depot: "",
//     courseName: "",
//     search: "",
//   });
//   const [reportFilterOptions, setReportFilterOptions] = useState({
//     states: [],
//     depots: [],
//     courses: [],
//   });
//   const [loadingFilterOptions, setLoadingFilterOptions] = useState(false);
  
//   // Filter State
//   const [filters, setFilters] = useState({
//     organizationId: getOrganizationId(),
//     state: "",
//     depot: "",
//     courseName: "",
//     failPass: "",
//     searchKeyword: "",
//   });
  
//   const [filterValues, setFilterValues] = useState({
//     states: [],
//     depots: [],
//     courseNames: [],
//     failPassStatuses: [],
//   });
  
//   const [showFilters, setShowFilters] = useState(true);
//   const [detailDialogOpen, setDetailDialogOpen] = useState(false);
//   const [selectedDetail, setSelectedDetail] = useState(null);
//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [selectedHistory, setSelectedHistory] = useState(null);
//   const [exportLoading, setExportLoading] = useState(false);
//   const [generateLoading, setGenerateLoading] = useState(false);
  
//   // Sorting
//   const [sortBy, setSortBy] = useState("trainingEndDate");
//   const [sortDirection, setSortDirection] = useState("DESC");

//   // ============================
//   // EFFECTS
//   // ============================
  
//   useEffect(() => {
//     const breadcrumbItems = [
//       { title: "Training Management", link: "#" },
//       { title: "Student Training History", link: "#" },
//     ];
//     setBreadcrumbItems("Student Training History", breadcrumbItems);
//   }, [setBreadcrumbItems]);

//   useEffect(() => {
//     const orgId = getOrganizationId();
//     setOrganizationId(orgId);
//     setFilters(prev => ({ ...prev, organizationId: orgId }));
//     loadInitialData(orgId);
//     loadReportFilterOptions(orgId);
//   }, []);

//   useEffect(() => {
//     if (filters.organizationId && !loader) {
//       fetchHistories();
//     }
//   }, [filters, currentPage, pageSize, sortBy, sortDirection]);

//   // ============================
//   // API FUNCTIONS
//   // ============================
  
//   const loadInitialData = async (orgId) => {
//     try {
//       setLoader(true);
//       setError(null);
//       await loadFilterValues(orgId);
//       await fetchHistories();
//     } catch (error) {
//       console.error("❌ Error loading initial data:", error);
//       setError("Failed to load data. Please refresh the page.");
//       toast.error("Failed to load data. Please refresh the page.");
//     } finally {
//       setLoader(false);
//     }
//   };

//   const loadFilterValues = async (orgId) => {
//     try {
//       const response = await getFilterValues(orgId);
//       if (response?.success) {
//         setFilterValues({
//           states: response.states || [],
//           depots: response.depots || [],
//           courseNames: response.courseNames || [],
//           failPassStatuses: response.failPassStatuses || [],
//         });
//       }
//     } catch (error) {
//       console.error("❌ Error loading filter values:", error);
//     }
//   };

//   const loadReportFilterOptions = async (orgId) => {
//     try {
//       setLoadingFilterOptions(true);
//       const [states, depots, courses] = await Promise.all([
//         getSdrStates(orgId),
//         getSdrDepots(orgId),
//         getSdrCourses(orgId),
//       ]);
      
//       setReportFilterOptions({
//         states: states || [],
//         depots: depots || [],
//         courses: courses || [],
//       });
//     } catch (error) {
//       console.error("❌ Error loading report filter options:", error);
//     } finally {
//       setLoadingFilterOptions(false);
//     }
//   };

//   const fetchHistories = async () => {
//     try {
//       setLoader(true);
//       setError(null);
      
//       const currentOrgId = filters.organizationId || organizationId || getOrganizationId();
      
//       const params = {
//         ...filters,
//         organizationId: currentOrgId,
//         page: currentPage,
//         size: pageSize,
//         sortBy: sortBy,
//         sortDirection: sortDirection,
//       };
      
//       console.log("📤 Fetching histories with params:", params);
      
//       const response = await getHistoriesWithFilters(params);
      
//       if (response?.success) {
//         const data = response.data || [];
//         setHistories(data);
//         setFilteredHistories(data);
//         setTotalRecords(response.totalRecords || data.length);
//         setTotalPages(response.totalPages || 0);
//         setCurrentPage(response.currentPage || 0);
//         console.log(`✅ Loaded ${data.length} records`);
//       } else {
//         setError(response?.message || "Failed to fetch histories");
//         toast.error(response?.message || "Failed to fetch histories");
//       }
//     } catch (error) {
//       console.error("❌ Error fetching histories:", error);
//       setError("Failed to load training histories. Please try again.");
//       toast.error("Failed to load training histories");
//     } finally {
//       setLoader(false);
//     }
//   };

//   // ============================
//   // HANDLER FUNCTIONS
//   // ============================
  
//   const handleFilterChange = (field, value) => {
//     setFilters(prev => ({ ...prev, [field]: value }));
//     setCurrentPage(0);
//   };

//   const handleClearFilters = () => {
//     setFilters({
//       ...filters,
//       state: "",
//       depot: "",
//       courseName: "",
//       failPass: "",
//       searchKeyword: "",
//     });
//     setCurrentPage(0);
//   };

//   const handlePageChange = (event, newPage) => {
//     setCurrentPage(newPage);
//   };

//   const handlePageSizeChange = (event) => {
//     setPageSize(parseInt(event.target.value, 10));
//     setCurrentPage(0);
//   };

//   const handleSort = (field) => {
//     const isAsc = sortBy === field && sortDirection === "ASC";
//     setSortDirection(isAsc ? "DESC" : "ASC");
//     setSortBy(field);
//   };

//   const handleViewDetail = (history) => {
//     setSelectedDetail(history);
//     setDetailDialogOpen(true);
//   };

//   const handleRefresh = () => {
//     fetchHistories();
//   };

//   const handleDeleteHistory = async () => {
//     if (!selectedHistory) return;
    
//     try {
//       setLoader(true);
//       const response = await deleteHistory(selectedHistory.id);
      
//       if (response?.success) {
//         toast.success("History deleted successfully");
//         setDeleteDialogOpen(false);
//         setSelectedHistory(null);
//         fetchHistories();
//       } else {
//         toast.error(response?.message || "Failed to delete history");
//       }
//     } catch (error) {
//       console.error("Error deleting history:", error);
//       toast.error("Failed to delete history");
//     } finally {
//       setLoader(false);
//     }
//   };

//   const handleDeleteAllForStudent = async (studentId) => {
//     if (!studentId) return;
    
//     if (!window.confirm("Are you sure you want to delete all histories for this student?")) {
//       return;
//     }
    
//     try {
//       setLoader(true);
//       const response = await deleteStudentHistory(studentId);
      
//       if (response?.success) {
//         toast.success("All histories deleted for student");
//         fetchHistories();
//       } else {
//         toast.error(response?.message || "Failed to delete histories");
//       }
//     } catch (error) {
//       console.error("Error deleting histories:", error);
//       toast.error("Failed to delete histories");
//     } finally {
//       setLoader(false);
//     }
//   };

//   const handleExportExcel = async () => {
//     try {
//       setExportLoading(true);
      
//       const params = {
//         ...filters,
//         sortBy: sortBy,
//         sortDirection: sortDirection,
//       };
      
//       const response = await exportHistoryExcel(params);
      
//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", `student_training_history_${new Date().toISOString().split('T')[0]}.xlsx`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
      
//       toast.success("Export completed successfully");
//     } catch (error) {
//       console.error("Error exporting:", error);
//       toast.error("Failed to export data");
//     } finally {
//       setExportLoading(false);
//     }
//   };

//   // ============================
//   // SDR REPORT FUNCTIONS
//   // ============================
  
//   const handleOpenReportModal = () => {
//     setReportModalOpen(true);
//     const orgId = filters.organizationId || organizationId || getOrganizationId();
//     loadReportFilterOptions(orgId);
//   };

//   const handleCloseReportModal = () => {
//     setReportModalOpen(false);
//     setReportType("all");
//     setReportFilters({
//       batchId: "",
//       state: "",
//       depot: "",
//       courseName: "",
//       search: "",
//     });
//   };

//   const handleReportFilterChange = (field, value) => {
//     setReportFilters(prev => ({ ...prev, [field]: value }));
//   };

//   const handleReportTypeChange = (event, newType) => {
//     if (newType !== null) {
//       setReportType(newType);
//       if (newType === "never-enrolled") {
//         setReportFilters(prev => ({ ...prev, batchId: "", courseName: "" }));
//       }
//     }
//   };

//   const handleGenerateReport = async () => {
//     try {
//       setReportLoading(true);
      
//       const orgId = filters.organizationId || organizationId || getOrganizationId();
      
//       // Build params with all filters
//       const params = {
//         organizationId: orgId,
//         search: reportFilters.search || null,
//         state: reportFilters.state || null,
//         depot: reportFilters.depot || null,
//       };
      
//       if (reportType === "all") {
//         params.batchId = reportFilters.batchId || null;
//         params.courseName = reportFilters.courseName || null;
//       }
      
//       console.log("📤 Generating report with params:", params);
      
//       let response;
//       let filename;
      
//       if (reportType === "all") {
//         response = await generateSdrReport(params);
//         filename = `SDR_Report_All_Students_${new Date().toISOString().split('T')[0]}.xlsx`;
//       } else {
//         response = await generateNeverEnrolledReport(params);
//         filename = `SDR_Report_Never_Enrolled_${new Date().toISOString().split('T')[0]}.xlsx`;
//       }
      
//       // Check if response is JSON error
//       const contentType = response.headers['content-type'];
//       if (contentType && contentType.includes('application/json')) {
//         const text = await response.data.text();
//         const errorData = JSON.parse(text);
//         toast.error(errorData.message || "Failed to generate report");
//         setReportLoading(false);
//         return;
//       }
      
//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", filename);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
      
//       toast.success(`SDR Report (${reportType === "all" ? "All Students" : "Never Enrolled"}) downloaded successfully!`);
//       handleCloseReportModal();
//     } catch (error) {
//       console.error("Error generating SDR Report:", error);
//       toast.error("Failed to generate SDR Report. Please try again.");
//     } finally {
//       setReportLoading(false);
//     }
//   };

//   // ============================
//   // UI HELPER FUNCTIONS
//   // ============================
  
//   const getStatusChip = (status) => {
//     if (!status) return <Chip label="N/A" size="small" variant="outlined" />;
    
//     const statusLower = status.toLowerCase();
//     if (statusLower.includes("pass")) {
//       return <Chip label="Pass" color="success" size="small" icon={<CheckCircleIcon />} />;
//     } else if (statusLower.includes("fail")) {
//       return <Chip label="Fail" color="error" size="small" icon={<CancelIcon />} />;
//     } else if (statusLower.includes("pending") || statusLower.includes("not attempted")) {
//       return <Chip label="Pending" color="warning" size="small" icon={<PendingIcon />} />;
//     }
//     return <Chip label={status} size="small" variant="outlined" />;
//   };

//   const getProgressColor = (progress) => {
//     if (!progress) return "default";
//     const num = parseInt(progress);
//     if (num >= 80) return "success";
//     if (num >= 50) return "warning";
//     return "error";
//   };

//   // ============================
//   // COLUMNS
//   // ============================
  
//   const columns = [
//     { id: "serialNo", label: "S.No.", minWidth: 60, sortable: true },
//     { id: "employeeId", label: "Employee Id", minWidth: 100, sortable: true },
//     { id: "participantName", label: "Participant Name", minWidth: 150, sortable: true },
//     { id: "fatherName", label: "Father Name", minWidth: 120, sortable: true },
//     { id: "courseName", label: "Course Name", minWidth: 150, sortable: true },
//     { id: "preTest", label: "Pre Test", minWidth: 80, sortable: true },
//     { id: "postTest", label: "Post Test", minWidth: 80, sortable: true },
//     { id: "practicalGrade", label: "Practical Grade", minWidth: 100, sortable: true },
//     { id: "failPass", label: "Fail/Pass", minWidth: 100, sortable: true },
//     { id: "remarks", label: "Remarks", minWidth: 120, sortable: false },
//     { id: "actions", label: "Actions", minWidth: 120, sortable: false },
//   ];

//   // ============================
//   // RENDER
//   // ============================
  
//   return (
//     <React.Fragment>
//       {loader && <Loader />}
      
//       <Row>
//         <Col className="col-12">
//           <Card>
//             <CardBody>
//               <CardTitle className="h4">
//                 <SchoolIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
//                 Student Training History
//                 <div className="float-end" style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
//                   <Button
//                     color="primary"
//                     onClick={() => setShowFilters(!showFilters)}
//                     style={{ display: "flex", alignItems: "center", gap: "5px" }}
//                   >
//                     <FilterIcon /> {showFilters ? "Hide Filters" : "Show Filters"}
//                   </Button>
//                   <Button
//                     color="success"
//                     onClick={handleExportExcel}
//                     disabled={exportLoading || filteredHistories.length === 0}
//                   >
//                     {exportLoading ? (
//                       <>
//                         <CircularProgress size={16} color="inherit" /> Exporting...
//                       </>
//                     ) : (
//                       <>
//                         <ExcelIcon /> Export
//                       </>
//                     )}
//                   </Button>
//                   <Button
//                     color="info"
//                     onClick={handleRefresh}
//                     disabled={loader}
//                   >
//                     <RefreshIcon /> Refresh
//                   </Button>
//                   <Button
//                     color="warning"
//                     onClick={handleOpenReportModal}
//                     style={{ display: "flex", alignItems: "center", gap: "5px" }}
//                   >
//                     <DownloadIcon /> SDR Report
//                   </Button>
//                 </div>
//               </CardTitle>

//               {/* Organization Info */}
//               <Alert severity="info" sx={{ mb: 2 }}>
//                 <AlertTitle>Organization Information</AlertTitle>
//                 <Typography variant="body2">
//                   Currently viewing data for Organization ID: <strong>{filters.organizationId || organizationId}</strong>
//                 </Typography>
//                 <Typography variant="caption" color="textSecondary">
//                   This organization ID is fetched from your logged-in user account.
//                 </Typography>
//               </Alert>

//               {/* Error Alert */}
//               {error && (
//                 <Alert severity="error" sx={{ mb: 3 }}>
//                   <AlertTitle>Error</AlertTitle>
//                   {error}
//                   <Button 
//                     color="primary" 
//                     size="sm" 
//                     onClick={handleRefresh}
//                     style={{ marginTop: '10px' }}
//                   >
//                     Retry
//                   </Button>
//                 </Alert>
//               )}

//               {/* Filter Section */}
//               <Collapse in={showFilters}>
//                 <Paper elevation={2} sx={{ p: 3, mb: 3, mt: 2 }}>
//                   <Grid container spacing={2} alignItems="center">
//                     <Grid item xs={12}>
//                       <Box display="flex" justifyContent="space-between" alignItems="center">
//                         <Typography variant="h6" gutterBottom>
//                           Filters
//                         </Typography>
//                         <IconButton size="small" onClick={handleClearFilters} sx={{ ml: 1 }}>
//                           <ClearIcon />
//                         </IconButton>
//                       </Box>
//                     </Grid>
                    
//                     <Grid item xs={12} md={4}>
//                       <TextField
//                         fullWidth
//                         size="small"
//                         label="Search Keyword"
//                         value={filters.searchKeyword}
//                         onChange={(e) => handleFilterChange("searchKeyword", e.target.value)}
//                         placeholder="Search by name, phone, aadhaar, emp ID, course..."
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <SearchIcon />
//                             </InputAdornment>
//                           ),
//                         }}
//                         onKeyPress={(e) => {
//                           if (e.key === 'Enter') {
//                             fetchHistories();
//                           }
//                         }}
//                       />
//                     </Grid>
                    
//                     <Grid item xs={12} md={2}>
//                       <FormControl fullWidth size="small">
//                         <InputLabel>State</InputLabel>
//                         <Select
//                           value={filters.state}
//                           label="State"
//                           onChange={(e) => handleFilterChange("state", e.target.value)}
//                         >
//                           <MenuItem value="">All States</MenuItem>
//                           {filterValues.states.map((state) => (
//                             <MenuItem key={state} value={state}>{state}</MenuItem>
//                           ))}
//                         </Select>
//                       </FormControl>
//                     </Grid>
                    
//                     <Grid item xs={12} md={2}>
//                       <FormControl fullWidth size="small">
//                         <InputLabel>Depot</InputLabel>
//                         <Select
//                           value={filters.depot}
//                           label="Depot"
//                           onChange={(e) => handleFilterChange("depot", e.target.value)}
//                         >
//                           <MenuItem value="">All Depots</MenuItem>
//                           {filterValues.depots.map((depot) => (
//                             <MenuItem key={depot} value={depot}>{depot}</MenuItem>
//                           ))}
//                         </Select>
//                       </FormControl>
//                     </Grid>
                    
//                     <Grid item xs={12} md={2}>
//                       <FormControl fullWidth size="small">
//                         <InputLabel>Course</InputLabel>
//                         <Select
//                           value={filters.courseName}
//                           label="Course"
//                           onChange={(e) => handleFilterChange("courseName", e.target.value)}
//                         >
//                           <MenuItem value="">All Courses</MenuItem>
//                           {filterValues.courseNames.map((course) => (
//                             <MenuItem key={course} value={course}>{course}</MenuItem>
//                           ))}
//                         </Select>
//                       </FormControl>
//                     </Grid>
                    
//                     <Grid item xs={12} md={2}>
//                       <FormControl fullWidth size="small">
//                         <InputLabel>Status</InputLabel>
//                         <Select
//                           value={filters.failPass}
//                           label="Status"
//                           onChange={(e) => handleFilterChange("failPass", e.target.value)}
//                         >
//                           <MenuItem value="">All Statuses</MenuItem>
//                           {filterValues.failPassStatuses.map((status) => (
//                             <MenuItem key={status} value={status}>{status}</MenuItem>
//                           ))}
//                         </Select>
//                       </FormControl>
//                     </Grid>
                    
//                     <Grid item xs={12}>
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         onClick={fetchHistories}
//                         disabled={loader}
//                       >
//                         {loader ? <CircularProgress size={20} /> : "Apply Filters"}
//                       </Button>
//                     </Grid>
//                   </Grid>
//                 </Paper>
//               </Collapse>

//               {/* Statistics Summary */}
//               <Paper elevation={2} sx={{ p: 2, mb: 3 }}>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12} sm={3}>
//                     <Box sx={{ textAlign: "center", p: 1 }}>
//                       <Typography variant="h4" color="primary">
//                         {totalRecords}
//                       </Typography>
//                       <Typography variant="body2" color="textSecondary">
//                         Total Records
//                       </Typography>
//                     </Box>
//                   </Grid>
//                   <Grid item xs={12} sm={3}>
//                     <Box sx={{ textAlign: "center", p: 1 }}>
//                       <Typography variant="h4" color="success.main">
//                         {filteredHistories.filter(h => h.failPass?.toLowerCase().includes("pass")).length}
//                       </Typography>
//                       <Typography variant="body2" color="textSecondary">
//                         Pass
//                       </Typography>
//                     </Box>
//                   </Grid>
//                   <Grid item xs={12} sm={3}>
//                     <Box sx={{ textAlign: "center", p: 1 }}>
//                       <Typography variant="h4" color="error.main">
//                         {filteredHistories.filter(h => h.failPass?.toLowerCase().includes("fail")).length}
//                       </Typography>
//                       <Typography variant="body2" color="textSecondary">
//                         Fail
//                       </Typography>
//                     </Box>
//                   </Grid>
//                   <Grid item xs={12} sm={3}>
//                     <Box sx={{ textAlign: "center", p: 1 }}>
//                       <Typography variant="h4" color="warning.main">
//                         {filteredHistories.filter(h => 
//                           h.failPass?.toLowerCase().includes("pending") || 
//                           h.failPass?.toLowerCase().includes("not attempted")
//                         ).length}
//                       </Typography>
//                       <Typography variant="body2" color="textSecondary">
//                         Pending
//                       </Typography>
//                     </Box>
//                   </Grid>
//                 </Grid>
//               </Paper>

//               {/* History Table */}
//               <Paper sx={{ width: "100%", overflow: "hidden" }}>
//                 <TableContainer sx={{ maxHeight: 600 }}>
//                   <Table stickyHeader size="small">
//                     <TableHead>
//                       <TableRow>
//                         {columns.map((column) => (
//                           <TableCell
//                             key={column.id}
//                             style={{ minWidth: column.minWidth, fontWeight: "bold", backgroundColor: "#f5f5f5" }}
//                           >
//                             {column.sortable ? (
//                               <TableSortLabel
//                                 active={sortBy === column.id}
//                                 direction={sortBy === column.id ? sortDirection.toLowerCase() : "asc"}
//                                 onClick={() => handleSort(column.id)}
//                               >
//                                 {column.label}
//                               </TableSortLabel>
//                             ) : (
//                               column.label
//                             )}
//                           </TableCell>
//                         ))}
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {filteredHistories.length === 0 ? (
//                         <TableRow>
//                           <TableCell colSpan={columns.length} align="center">
//                             <Typography variant="body1" sx={{ py: 3 }}>
//                               {loader ? "Loading..." : `No training history records found`}
//                             </Typography>
//                           </TableCell>
//                         </TableRow>
//                       ) : (
//                         filteredHistories.map((history, index) => {
//                           const isFirstRow = index === 0 || 
//                             filteredHistories[index - 1]?.studentId !== history.studentId;
                          
//                           const studentRowCount = filteredHistories.filter(
//                             h => h.studentId === history.studentId
//                           ).length;
                          
//                           return (
//                             <TableRow key={history.id} hover>
//                               {isFirstRow ? (
//                                 <TableCell rowSpan={studentRowCount}>
//                                   <Typography variant="body2" fontWeight="bold">
//                                     {history.serialNo || index + 1}
//                                   </Typography>
//                                 </TableCell>
//                               ) : null}
                              
//                               {isFirstRow ? (
//                                 <TableCell rowSpan={studentRowCount}>
//                                   {history.employeeId || "N/A"}
//                                 </TableCell>
//                               ) : null}
                              
//                               {isFirstRow ? (
//                                 <TableCell rowSpan={studentRowCount}>
//                                   <Typography variant="body2" fontWeight="bold">
//                                     {history.participantName || "N/A"}
//                                   </Typography>
//                                 </TableCell>
//                               ) : null}
                              
//                               {isFirstRow ? (
//                                 <TableCell rowSpan={studentRowCount}>
//                                   {history.fatherName || "N/A"}
//                                 </TableCell>
//                               ) : null}
                              
//                               <TableCell>
//                                 <Tooltip title={history.courseName}>
//                                   <Typography variant="body2" noWrap sx={{ maxWidth: 140 }}>
//                                     {history.courseName || "N/A"}
//                                   </Typography>
//                                 </Tooltip>
//                               </TableCell>
//                               <TableCell>
//                                 <Chip
//                                   label={history.preTest || "0%"}
//                                   size="small"
//                                   color={getProgressColor(history.preTest)}
//                                 />
//                               </TableCell>
//                               <TableCell>
//                                 <Chip
//                                   label={history.postTest || "0%"}
//                                   size="small"
//                                   color={getProgressColor(history.postTest)}
//                                 />
//                               </TableCell>
//                               <TableCell>
//                                 <Chip
//                                   label={history.practicalGrade || "N/A"}
//                                   size="small"
//                                   variant="outlined"
//                                 />
//                               </TableCell>
//                               <TableCell>{getStatusChip(history.failPass)}</TableCell>
//                               <TableCell>
//                                 <Typography variant="body2" noWrap sx={{ maxWidth: 100 }}>
//                                   {history.remarks || "N/A"}
//                                 </Typography>
//                               </TableCell>
                              
//                               {isFirstRow ? (
//                                 <TableCell rowSpan={studentRowCount}>
//                                   <Box display="flex" flexDirection="column" gap={0.5}>
//                                     <Tooltip title="View Details">
//                                       <IconButton
//                                         size="small"
//                                         color="primary"
//                                         onClick={() => handleViewDetail(history)}
//                                       >
//                                         <VisibilityIcon fontSize="small" />
//                                       </IconButton>
//                                     </Tooltip>
//                                     <Tooltip title="Delete All for Student">
//                                       <IconButton
//                                         size="small"
//                                         color="error"
//                                         onClick={() => {
//                                           if (window.confirm(`Delete all histories for ${history.participantName}?`)) {
//                                             handleDeleteAllForStudent(history.studentId);
//                                           }
//                                         }}
//                                       >
//                                         <DeleteIcon fontSize="small" />
//                                       </IconButton>
//                                     </Tooltip>
//                                   </Box>
//                                 </TableCell>
//                               ) : null}
//                             </TableRow>
//                           );
//                         })
//                       )}
//                     </TableBody>
//                   </Table>
//                 </TableContainer>
                
//                 <TablePagination
//                   rowsPerPageOptions={[10, 25, 50, 100]}
//                   component="div"
//                   count={totalRecords}
//                   rowsPerPage={pageSize}
//                   page={currentPage}
//                   onPageChange={handlePageChange}
//                   onRowsPerPageChange={handlePageSizeChange}
//                 />
//               </Paper>
//             </CardBody>
//           </Card>
//         </Col>
//       </Row>

//       {/* ============================
//           SDR REPORT MODAL
//           ============================ */}
//       <Dialog
//         open={reportModalOpen}
//         onClose={handleCloseReportModal}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>
//           <Box display="flex" justifyContent="space-between" alignItems="center">
//             <Typography variant="h6">
//               <DownloadIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
//               Generate SDR Report
//             </Typography>
//             <IconButton onClick={handleCloseReportModal}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent dividers>
//           {/* Report Type Selection */}
//           <Box sx={{ mb: 3 }}>
//             <Typography variant="subtitle2" gutterBottom>
//               Select Report Type
//             </Typography>
//             <ToggleButtonGroup
//               value={reportType}
//               exclusive
//               onChange={handleReportTypeChange}
//               aria-label="report type"
//               size="small"
//             >
//               <ToggleButton value="all" aria-label="all students">
//                 <PeopleIcon sx={{ mr: 1, fontSize: 20 }} />
//                 All Students (With History)
//               </ToggleButton>
//               <ToggleButton value="never-enrolled" aria-label="never enrolled">
//                 <PersonOffIcon sx={{ mr: 1, fontSize: 20 }} />
//                 Never Enrolled
//               </ToggleButton>
//             </ToggleButtonGroup>
            
//             <Box sx={{ mt: 1 }}>
//               {reportType === "all" ? (
//                 <Chip 
//                   icon={<InfoIcon />} 
//                   label="Shows all students with their training history. Same S.No. for same student across multiple courses."
//                   color="info"
//                   variant="outlined"
//                   size="small"
//                   sx={{ width: '100%', justifyContent: 'flex-start' }}
//                 />
//               ) : (
//                 <Chip 
//                   icon={<InfoIcon />} 
//                   label="Shows students who are not enrolled in any batch. Includes basic student information."
//                   color="warning"
//                   variant="outlined"
//                   size="small"
//                   sx={{ width: '100%', justifyContent: 'flex-start' }}
//                 />
//               )}
//             </Box>
//           </Box>

//           {/* Report Filters */}
//           <Typography variant="subtitle2" gutterBottom>
//             Filters
//           </Typography>
//           <Grid container spacing={2}>
//             <Grid item xs={12} md={4}>
//               <TextField
//                 fullWidth
//                 size="small"
//                 label="Search"
//                 value={reportFilters.search}
//                 onChange={(e) => handleReportFilterChange("search", e.target.value)}
//                 placeholder="Name, Phone, Aadhaar..."
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <SearchIcon />
//                     </InputAdornment>
//                   ),
//                 }}
//               />
//             </Grid>
            
//             {reportType === "all" && (
//               <Grid item xs={12} md={4}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="Batch ID"
//                   type="number"
//                   value={reportFilters.batchId}
//                   onChange={(e) => handleReportFilterChange("batchId", e.target.value)}
//                   placeholder="Enter batch ID"
//                 />
//               </Grid>
//             )}
            
//             <Grid item xs={12} md={4}>
//               <FormControl fullWidth size="small">
//                 <InputLabel>State</InputLabel>
//                 <Select
//                   value={reportFilters.state}
//                   label="State"
//                   onChange={(e) => handleReportFilterChange("state", e.target.value)}
//                 >
//                   <MenuItem value="">All States</MenuItem>
//                   {reportFilterOptions.states.map((state) => (
//                     <MenuItem key={state} value={state}>{state}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
            
//             <Grid item xs={12} md={4}>
//               <FormControl fullWidth size="small">
//                 <InputLabel>Depot</InputLabel>
//                 <Select
//                   value={reportFilters.depot}
//                   label="Depot"
//                   onChange={(e) => handleReportFilterChange("depot", e.target.value)}
//                 >
//                   <MenuItem value="">All Depots</MenuItem>
//                   {reportFilterOptions.depots.map((depot) => (
//                     <MenuItem key={depot} value={depot}>{depot}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
            
//             {reportType === "all" && (
//               <Grid item xs={12} md={4}>
//                 <FormControl fullWidth size="small">
//                   <InputLabel>Course</InputLabel>
//                   <Select
//                     value={reportFilters.courseName}
//                     label="Course"
//                     onChange={(e) => handleReportFilterChange("courseName", e.target.value)}
//                   >
//                     <MenuItem value="">All Courses</MenuItem>
//                     {reportFilterOptions.courses.map((course) => (
//                       <MenuItem key={course} value={course}>{course}</MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Grid>
//             )}
//           </Grid>

//           {/* Info Box */}
//           <Box sx={{ mt: 3, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
//             <Typography variant="caption" color="textSecondary">
//               <strong>Note:</strong> The SDR Report is optimized for large datasets (50K+ records).
//               {reportType === "all" ? (
//                 " Each student gets a unique serial number that remains the same across all their course rows."
//               ) : (
//                 " Shows students who are not enrolled in any batch."
//               )}
//             </Typography>
//           </Box>
          
//           {/* Loading indicator for filter options */}
//           {loadingFilterOptions && (
//             <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
//               <CircularProgress size={24} />
//               <Typography variant="caption" sx={{ ml: 1 }}>
//                 Loading filter options...
//               </Typography>
//             </Box>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseReportModal} color="secondary">
//             Cancel
//           </Button>
//           <Button 
//             onClick={handleGenerateReport} 
//             color="warning"
//             disabled={reportLoading}
//             variant="contained"
//           >
//             {reportLoading ? (
//               <>
//                 <CircularProgress size={20} sx={{ mr: 1 }} />
//                 Generating...
//               </>
//             ) : (
//               <>
//                 <DownloadIcon sx={{ mr: 1 }} />
//                 Generate Report
//               </>
//             )}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Detail View Dialog */}
//       <Dialog
//         open={detailDialogOpen}
//         onClose={() => setDetailDialogOpen(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>
//           <Box display="flex" justifyContent="space-between" alignItems="center">
//             <Typography variant="h6">Training History Details</Typography>
//             <IconButton onClick={() => setDetailDialogOpen(false)}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent dividers>
//           {selectedDetail && (
//             <Grid container spacing={2}>
//               <Grid item xs={12}>
//                 <Typography variant="subtitle1" color="primary" gutterBottom>
//                   Candidate Information
//                 </Typography>
//                 <Paper variant="outlined" sx={{ p: 2 }}>
//                   <Grid container spacing={1}>
//                     <Grid item xs={6}>
//                       <Typography variant="body2"><strong>Name:</strong> {selectedDetail.participantName || "N/A"}</Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                       <Typography variant="body2"><strong>Employee ID:</strong> {selectedDetail.employeeId || "N/A"}</Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                       <Typography variant="body2"><strong>Father Name:</strong> {selectedDetail.fatherName || "N/A"}</Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                       <Typography variant="body2"><strong>Phone:</strong> {selectedDetail.phoneNumber || "N/A"}</Typography>
//                     </Grid>
//                   </Grid>
//                 </Paper>
//               </Grid>

//               <Grid item xs={12}>
//                 <Typography variant="subtitle1" color="primary" gutterBottom>
//                   Training Details
//                 </Typography>
//                 <Paper variant="outlined" sx={{ p: 2 }}>
//                   <Grid container spacing={1}>
//                     <Grid item xs={6}>
//                       <Typography variant="body2"><strong>Course:</strong> {selectedDetail.courseName || "N/A"}</Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                       <Typography variant="body2"><strong>Depot:</strong> {selectedDetail.depot || "N/A"}</Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                       <Typography variant="body2"><strong>State:</strong> {selectedDetail.state || "N/A"}</Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                       <Typography variant="body2"><strong>Training Mode:</strong> {selectedDetail.trainingMode || "N/A"}</Typography>
//                     </Grid>
//                   </Grid>
//                 </Paper>
//               </Grid>

//               <Grid item xs={12}>
//                 <Typography variant="subtitle1" color="primary" gutterBottom>
//                   Results
//                 </Typography>
//                 <Paper variant="outlined" sx={{ p: 2 }}>
//                   <Grid container spacing={1}>
//                     <Grid item xs={4}>
//                       <Typography variant="body2"><strong>Pre Test:</strong> {selectedDetail.preTest || "0%"}</Typography>
//                     </Grid>
//                     <Grid item xs={4}>
//                       <Typography variant="body2"><strong>Post Test:</strong> {selectedDetail.postTest || "0%"}</Typography>
//                     </Grid>
//                     <Grid item xs={4}>
//                       <Typography variant="body2"><strong>Practical Grade:</strong> {selectedDetail.practicalGrade || "N/A"}</Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                       <Typography variant="body2"><strong>Status:</strong> {getStatusChip(selectedDetail.failPass)}</Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                       <Typography variant="body2"><strong>Remarks:</strong> {selectedDetail.remarks || "N/A"}</Typography>
//                     </Grid>
//                   </Grid>
//                 </Paper>
//               </Grid>
//             </Grid>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDetailDialogOpen(false)} color="secondary">
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Delete Confirmation Dialog */}
//       <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
//         <DialogTitle>Confirm Delete</DialogTitle>
//         <DialogContent>
//           <Typography>
//             Are you sure you want to delete this training history?
//           </Typography>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDeleteDialogOpen(false)} color="secondary">
//             Cancel
//           </Button>
//           <Button onClick={handleDeleteHistory} color="error">
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </React.Fragment>
//   );
// };

// // ============================
// // MAP STATE TO PROPS
// // ============================
// const mapStateToProps = (state) => {
//   return {
//     auth: state.auth || state.login || state,
//   };
// };

// export default connect(mapStateToProps, { setBreadcrumbItems })(StudentTrainingHistory);












// src/pages/StudentTrainingHistory/StudentTrainingHistory.jsx
import React, { useEffect, useState, useMemo } from "react";
import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap";
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";
import Loader from "components/Loader/Loader";
import { toast } from "react-toastify";
import {
  getHistoriesWithFilters,
  getFilterValues,
  getAutoGenerationStatus,
  deleteHistory,
  deleteStudentHistory,
  generateBatchHistory,
  exportHistoryExcel,
} from "helpers/student_training_history_helper";
import {
  generateSdrReport,
  generateNeverEnrolledReport,
  getSdrStates,
  getSdrDepots,
  getSdrCourses,
} from "helpers/sdr_report_helper";
import {
  Paper,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Chip,
  CircularProgress,
  Alert,
  AlertTitle,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TableSortLabel,
  Tooltip,
  Collapse,
  ToggleButton,
  ToggleButtonGroup,
  InputAdornment,
} from "@mui/material";
import {
  Close as CloseIcon,
  FilterList as FilterIcon,
  Clear as ClearIcon,
  School as SchoolIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Pending as PendingIcon,
  Refresh as RefreshIcon,
  Visibility as VisibilityIcon,
  Delete as DeleteIcon,
  GridOn as ExcelIcon,
  Download as DownloadIcon,
  People as PeopleIcon,
  PersonOff as PersonOffIcon,
  Info as InfoIcon,
  Search as SearchIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const StudentTrainingHistory = (props) => {
  document.title = "Question System | Student Training History";
  
  const navigate = useNavigate();
  const { setBreadcrumbItems } = props;

  // ============================
  // GET ORGANIZATION ID
  // ============================
  const getOrganizationId = () => {
    try {
      const authUser = JSON.parse(localStorage.getItem("authUser"));
      if (authUser?.organizationId) return authUser.organizationId;
      if (authUser?.organization?.id) return authUser.organization.id;
      if (props.auth?.user?.organizationId) return props.auth.user.organizationId;
      if (props.auth?.organizationId) return props.auth.organizationId;
      return 2;
    } catch (error) {
      return 2;
    }
  };

  // ============================
  // STATE
  // ============================
  const [loader, setLoader] = useState(false);
  const [histories, setHistories] = useState([]);
  const [filteredHistories, setFilteredHistories] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [error, setError] = useState(null);
  
  const [organizationId, setOrganizationId] = useState(getOrganizationId());
  
  // Search State (separate from filters)
  const [searchKeyword, setSearchKeyword] = useState("");
  
  // Report Modal State
  const [reportModalOpen, setReportModalOpen] = useState(false);
  const [reportType, setReportType] = useState("all");
  const [reportLoading, setReportLoading] = useState(false);
  const [reportFilters, setReportFilters] = useState({
    batchId: "",
    state: "",
    depot: "",
    courseName: "",
    search: "",
  });
  const [reportFilterOptions, setReportFilterOptions] = useState({
    states: [],
    depots: [],
    courses: [],
  });
  const [loadingFilterOptions, setLoadingFilterOptions] = useState(false);
  
  // Filter State
  const [filters, setFilters] = useState({
    organizationId: getOrganizationId(),
    state: "",
    depot: "",
    courseName: "",
    failPass: "",
  });
  
  const [filterValues, setFilterValues] = useState({
    states: [],
    depots: [],
    courseNames: [],
    failPassStatuses: [],
  });
  
  const [showFilters, setShowFilters] = useState(true);
  const [detailDialogOpen, setDetailDialogOpen] = useState(false);
  const [selectedDetail, setSelectedDetail] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedHistory, setSelectedHistory] = useState(null);
  const [exportLoading, setExportLoading] = useState(false);
  const [generateLoading, setGenerateLoading] = useState(false);
  
  // Sorting
  const [sortBy, setSortBy] = useState("trainingEndDate");
  const [sortDirection, setSortDirection] = useState("DESC");

  // ============================
  // EFFECTS
  // ============================
  
  useEffect(() => {
    const breadcrumbItems = [
      { title: "Training Management", link: "#" },
      { title: "Student Training History", link: "#" },
    ];
    setBreadcrumbItems("Student Training History", breadcrumbItems);
  }, [setBreadcrumbItems]);

  useEffect(() => {
    const orgId = getOrganizationId();
    setOrganizationId(orgId);
    setFilters(prev => ({ ...prev, organizationId: orgId }));
    loadInitialData(orgId);
    loadReportFilterOptions(orgId);
  }, []);

  // Fetch when filters, pagination, or sorting changes (NOT search - handled separately)
  useEffect(() => {
    if (filters.organizationId && !loader) {
      fetchHistories();
    }
  }, [filters, currentPage, pageSize, sortBy, sortDirection]);

  // ============================
  // API FUNCTIONS
  // ============================
  
  const loadInitialData = async (orgId) => {
    try {
      setLoader(true);
      setError(null);
      await loadFilterValues(orgId);
      await fetchHistories();
    } catch (error) {
      console.error("❌ Error loading initial data:", error);
      setError("Failed to load data. Please refresh the page.");
      toast.error("Failed to load data. Please refresh the page.");
    } finally {
      setLoader(false);
    }
  };

  const loadFilterValues = async (orgId) => {
    try {
      const response = await getFilterValues(orgId);
      if (response?.success) {
        setFilterValues({
          states: response.states || [],
          depots: response.depots || [],
          courseNames: response.courseNames || [],
          failPassStatuses: response.failPassStatuses || [],
        });
      }
    } catch (error) {
      console.error("❌ Error loading filter values:", error);
    }
  };

  const loadReportFilterOptions = async (orgId) => {
    try {
      setLoadingFilterOptions(true);
      const [states, depots, courses] = await Promise.all([
        getSdrStates(orgId),
        getSdrDepots(orgId),
        getSdrCourses(orgId),
      ]);
      
      setReportFilterOptions({
        states: states || [],
        depots: depots || [],
        courses: courses || [],
      });
    } catch (error) {
      console.error("❌ Error loading report filter options:", error);
    } finally {
      setLoadingFilterOptions(false);
    }
  };

  const fetchHistories = async () => {
    try {
      setLoader(true);
      setError(null);
      
      const currentOrgId = filters.organizationId || organizationId || getOrganizationId();
      
      // Build params including searchKeyword from separate state
      const params = {
        organizationId: currentOrgId,
        state: filters.state || null,
        depot: filters.depot || null,
        courseName: filters.courseName || null,
        failPass: filters.failPass || null,
        search: searchKeyword || null,  // Search keyword
        page: currentPage,
        size: pageSize,
        sortBy: sortBy,
        sortDirection: sortDirection,
      };
      
      console.log("📤 Fetching histories with params:", params);
      
      const response = await getHistoriesWithFilters(params);
      
      if (response?.success) {
        const data = response.data || [];
        setHistories(data);
        setFilteredHistories(data);
        setTotalRecords(response.totalRecords || data.length);
        setTotalPages(response.totalPages || 0);
        setCurrentPage(response.currentPage || 0);
        console.log(`✅ Loaded ${data.length} records`);
      } else {
        setError(response?.message || "Failed to fetch histories");
        toast.error(response?.message || "Failed to fetch histories");
      }
    } catch (error) {
      console.error("❌ Error fetching histories:", error);
      setError("Failed to load training histories. Please try again.");
      toast.error("Failed to load training histories");
    } finally {
      setLoader(false);
    }
  };

  // ============================
  // SEARCH HANDLERS
  // ============================
  
  // Handle search input change - just update state, don't fetch
  const handleSearchChange = (e) => {
    setSearchKeyword(e.target.value);
  };

  // Handle search on Enter key - fetch from backend and reset to page 0
  const handleSearchKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      setCurrentPage(0);  // Reset to first page
      // Use setTimeout to ensure state is updated before fetch
      setTimeout(() => {
        fetchHistoriesWithSearch(0);
      }, 0);
    }
  };

  // Handle search button click
  const handleSearchClick = () => {
    setCurrentPage(0);
    setTimeout(() => {
      fetchHistoriesWithSearch(0);
    }, 0);
  };

  // Clear search
  const handleClearSearch = () => {
    setSearchKeyword("");
    setCurrentPage(0);
    setTimeout(() => {
      fetchHistoriesWithSearch(0, true);
    }, 0);
  };

  // Fetch with search parameter (bypasses useEffect)
  const fetchHistoriesWithSearch = async (page = 0, clearSearch = false) => {
    try {
      setLoader(true);
      setError(null);
      
      const currentOrgId = filters.organizationId || organizationId || getOrganizationId();
      const searchValue = clearSearch ? null : (searchKeyword || null);
      
      const params = {
        organizationId: currentOrgId,
        state: filters.state || null,
        depot: filters.depot || null,
        courseName: filters.courseName || null,
        failPass: filters.failPass || null,
        search: searchValue,
        page: page,
        size: pageSize,
        sortBy: sortBy,
        sortDirection: sortDirection,
      };
      
      console.log("🔍 Searching with params:", params);
      
      const response = await getHistoriesWithFilters(params);
      
      if (response?.success) {
        const data = response.data || [];
        setHistories(data);
        setFilteredHistories(data);
        setTotalRecords(response.totalRecords || data.length);
        setTotalPages(response.totalPages || 0);
        setCurrentPage(response.currentPage || 0);
        
        if (data.length === 0 && searchValue) {
          toast.info(`No records found for "${searchValue}"`);
        } else {
          console.log(`✅ Found ${data.length} records for search: "${searchValue || 'all'}"`);
        }
      } else {
        setError(response?.message || "Failed to search histories");
        toast.error(response?.message || "Failed to search histories");
      }
    } catch (error) {
      console.error("❌ Error searching histories:", error);
      setError("Failed to search training histories.");
      toast.error("Failed to search training histories");
    } finally {
      setLoader(false);
    }
  };

  // ============================
  // HANDLER FUNCTIONS
  // ============================
  
  const handleFilterChange = (field, value) => {
    setFilters(prev => ({ ...prev, [field]: value }));
    setCurrentPage(0);
  };

  const handleClearFilters = () => {
    setFilters({
      ...filters,
      state: "",
      depot: "",
      courseName: "",
      failPass: "",
    });
    setSearchKeyword("");
    setCurrentPage(0);
    // Fetch with cleared filters
    setTimeout(() => {
      fetchHistoriesWithSearch(0, true);
    }, 0);
  };

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handlePageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  const handleSort = (field) => {
    const isAsc = sortBy === field && sortDirection === "ASC";
    setSortDirection(isAsc ? "DESC" : "ASC");
    setSortBy(field);
  };

  const handleViewDetail = (history) => {
    setSelectedDetail(history);
    setDetailDialogOpen(true);
  };

  const handleRefresh = () => {
    fetchHistoriesWithSearch(currentPage);
  };

  const handleDeleteHistory = async () => {
    if (!selectedHistory) return;
    
    try {
      setLoader(true);
      const response = await deleteHistory(selectedHistory.id);
      
      if (response?.success) {
        toast.success("History deleted successfully");
        setDeleteDialogOpen(false);
        setSelectedHistory(null);
        fetchHistoriesWithSearch(currentPage);
      } else {
        toast.error(response?.message || "Failed to delete history");
      }
    } catch (error) {
      console.error("Error deleting history:", error);
      toast.error("Failed to delete history");
    } finally {
      setLoader(false);
    }
  };

  const handleDeleteAllForStudent = async (studentId) => {
    if (!studentId) return;
    
    if (!window.confirm("Are you sure you want to delete all histories for this student?")) {
      return;
    }
    
    try {
      setLoader(true);
      const response = await deleteStudentHistory(studentId);
      
      if (response?.success) {
        toast.success("All histories deleted for student");
        fetchHistoriesWithSearch(currentPage);
      } else {
        toast.error(response?.message || "Failed to delete histories");
      }
    } catch (error) {
      console.error("Error deleting histories:", error);
      toast.error("Failed to delete histories");
    } finally {
      setLoader(false);
    }
  };

  const handleExportExcel = async () => {
    try {
      setExportLoading(true);
      
      const params = {
        organizationId: filters.organizationId || organizationId,
        state: filters.state || null,
        depot: filters.depot || null,
        courseName: filters.courseName || null,
        failPass: filters.failPass || null,
        search: searchKeyword || null,
        sortBy: sortBy,
        sortDirection: sortDirection,
      };
      
      const response = await exportHistoryExcel(params);
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `student_training_history_${new Date().toISOString().split('T')[0]}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      
      toast.success("Export completed successfully");
    } catch (error) {
      console.error("Error exporting:", error);
      toast.error("Failed to export data");
    } finally {
      setExportLoading(false);
    }
  };

  // ============================
  // SDR REPORT FUNCTIONS
  // ============================
  
  const handleOpenReportModal = () => {
    setReportModalOpen(true);
    const orgId = filters.organizationId || organizationId || getOrganizationId();
    loadReportFilterOptions(orgId);
  };

  const handleCloseReportModal = () => {
    setReportModalOpen(false);
    setReportType("all");
    setReportFilters({
      batchId: "",
      state: "",
      depot: "",
      courseName: "",
      search: "",
    });
  };

  const handleReportFilterChange = (field, value) => {
    setReportFilters(prev => ({ ...prev, [field]: value }));
  };

  const handleReportTypeChange = (event, newType) => {
    if (newType !== null) {
      setReportType(newType);
      if (newType === "never-enrolled") {
        setReportFilters(prev => ({ ...prev, batchId: "", courseName: "" }));
      }
    }
  };

  const handleGenerateReport = async () => {
    try {
      setReportLoading(true);
      
      const orgId = filters.organizationId || organizationId || getOrganizationId();
      
      const params = {
        organizationId: orgId,
        search: reportFilters.search || null,
        state: reportFilters.state || null,
        depot: reportFilters.depot || null,
      };
      
      if (reportType === "all") {
        params.batchId = reportFilters.batchId || null;
        params.courseName = reportFilters.courseName || null;
      }
      
      console.log("📤 Generating report with params:", params);
      
      let response;
      let filename;
      
      if (reportType === "all") {
        response = await generateSdrReport(params);
        filename = `SDR_Report_All_Students_${new Date().toISOString().split('T')[0]}.xlsx`;
      } else {
        response = await generateNeverEnrolledReport(params);
        filename = `SDR_Report_Never_Enrolled_${new Date().toISOString().split('T')[0]}.xlsx`;
      }
      
      const contentType = response.headers['content-type'];
      if (contentType && contentType.includes('application/json')) {
        const text = await response.data.text();
        const errorData = JSON.parse(text);
        toast.error(errorData.message || "Failed to generate report");
        setReportLoading(false);
        return;
      }
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      
      toast.success(`SDR Report (${reportType === "all" ? "All Students" : "Never Enrolled"}) downloaded successfully!`);
      handleCloseReportModal();
    } catch (error) {
      console.error("Error generating SDR Report:", error);
      toast.error("Failed to generate SDR Report. Please try again.");
    } finally {
      setReportLoading(false);
    }
  };

  // ============================
  // UI HELPER FUNCTIONS
  // ============================
  
  const getStatusChip = (status) => {
    if (!status) return <Chip label="N/A" size="small" variant="outlined" />;
    
    const statusLower = status.toLowerCase();
    if (statusLower.includes("pass")) {
      return <Chip label="Pass" color="success" size="small" icon={<CheckCircleIcon />} />;
    } else if (statusLower.includes("fail")) {
      return <Chip label="Fail" color="error" size="small" icon={<CancelIcon />} />;
    } else if (statusLower.includes("pending") || statusLower.includes("not attempted")) {
      return <Chip label="Pending" color="warning" size="small" icon={<PendingIcon />} />;
    }
    return <Chip label={status} size="small" variant="outlined" />;
  };

  const getProgressColor = (progress) => {
    if (!progress) return "default";
    const num = parseInt(progress);
    if (num >= 80) return "success";
    if (num >= 50) return "warning";
    return "error";
  };

  // ============================
  // COLUMNS
  // ============================
  
  const columns = [
    { id: "serialNo", label: "S.No.", minWidth: 60, sortable: true },
    { id: "employeeId", label: "Employee Id", minWidth: 100, sortable: true },
    { id: "participantName", label: "Participant Name", minWidth: 150, sortable: true },
    { id: "fatherName", label: "Father Name", minWidth: 120, sortable: true },
    { id: "courseName", label: "Course Name", minWidth: 150, sortable: true },
    { id: "preTest", label: "Pre Test", minWidth: 80, sortable: true },
    { id: "postTest", label: "Post Test", minWidth: 80, sortable: true },
    { id: "practicalGrade", label: "Practical Grade", minWidth: 100, sortable: true },
    { id: "failPass", label: "Fail/Pass", minWidth: 100, sortable: true },
    { id: "remarks", label: "Remarks", minWidth: 120, sortable: false },
    { id: "actions", label: "Actions", minWidth: 120, sortable: false },
  ];

  // ============================
  // RENDER
  // ============================
  
  return (
    <React.Fragment>
      {loader && <Loader />}
      
      <Row>
        <Col className="col-12">
          <Card>
            <CardBody>
              <CardTitle className="h4">
                <SchoolIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
                Student Training History
                <div className="float-end" style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                  <Button
                    color="primary"
                    onClick={() => setShowFilters(!showFilters)}
                    style={{ display: "flex", alignItems: "center", gap: "5px" }}
                  >
                    <FilterIcon /> {showFilters ? "Hide Filters" : "Show Filters"}
                  </Button>
                  <Button
                    color="success"
                    onClick={handleExportExcel}
                    disabled={exportLoading || filteredHistories.length === 0}
                  >
                    {exportLoading ? (
                      <>
                        <CircularProgress size={16} color="inherit" /> Exporting...
                      </>
                    ) : (
                      <>
                        <ExcelIcon /> Export
                      </>
                    )}
                  </Button>
                  <Button
                    color="info"
                    onClick={handleRefresh}
                    disabled={loader}
                  >
                    <RefreshIcon /> Refresh
                  </Button>
                  <Button
                    color="warning"
                    onClick={handleOpenReportModal}
                    style={{ display: "flex", alignItems: "center", gap: "5px" }}
                  >
                    <DownloadIcon /> SDR Report
                  </Button>
                </div>
              </CardTitle>

              {/* Organization Info */}
              <Alert severity="info" sx={{ mb: 2 }}>
                <AlertTitle>Organization Information</AlertTitle>
                <Typography variant="body2">
                  Currently viewing data for Organization ID: <strong>{filters.organizationId || organizationId}</strong>
                </Typography>
                <Typography variant="caption" color="textSecondary">
                  This organization ID is fetched from your logged-in user account.
                </Typography>
              </Alert>

              {/* Error Alert */}
              {error && (
                <Alert severity="error" sx={{ mb: 3 }}>
                  <AlertTitle>Error</AlertTitle>
                  {error}
                  <Button 
                    color="primary" 
                    size="sm" 
                    onClick={handleRefresh}
                    style={{ marginTop: '10px' }}
                  >
                    Retry
                  </Button>
                </Alert>
              )}

              {/* Filter Section */}
              <Collapse in={showFilters}>
                <Paper elevation={2} sx={{ p: 3, mb: 3, mt: 2 }}>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12}>
                      <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="h6" gutterBottom>
                          Filters
                        </Typography>
                        <IconButton size="small" onClick={handleClearFilters} sx={{ ml: 1 }}>
                          <ClearIcon />
                        </IconButton>
                      </Box>
                    </Grid>
                    
                    {/* ============================
                        SEARCH BAR - FIXED
                        ============================ */}
                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Search Keyword"
                        value={searchKeyword}
                        onChange={handleSearchChange}
                        onKeyPress={handleSearchKeyPress}
                        placeholder="Search by name, phone, aadhaar, emp ID... (Press Enter)"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                          endAdornment: searchKeyword && (
                            <InputAdornment position="end">
                              <IconButton
                                size="small"
                                onClick={handleClearSearch}
                                edge="end"
                              >
                                <ClearIcon fontSize="small" />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    
                    <Grid item xs={12} md={2}>
                      <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        onClick={handleSearchClick}
                        disabled={loader}
                        startIcon={<SearchIcon />}
                        style={{ height: '40px' }}
                      >
                        Search
                      </Button>
                    </Grid>
                    
                    <Grid item xs={12} md={2}>
                      <FormControl fullWidth size="small">
                        <InputLabel>State</InputLabel>
                        <Select
                          value={filters.state}
                          label="State"
                          onChange={(e) => handleFilterChange("state", e.target.value)}
                        >
                          <MenuItem value="">All States</MenuItem>
                          {filterValues.states.map((state) => (
                            <MenuItem key={state} value={state}>{state}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    
                    <Grid item xs={12} md={2}>
                      <FormControl fullWidth size="small">
                        <InputLabel>Depot</InputLabel>
                        <Select
                          value={filters.depot}
                          label="Depot"
                          onChange={(e) => handleFilterChange("depot", e.target.value)}
                        >
                          <MenuItem value="">All Depots</MenuItem>
                          {filterValues.depots.map((depot) => (
                            <MenuItem key={depot} value={depot}>{depot}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    
                    <Grid item xs={12} md={2}>
                      <FormControl fullWidth size="small">
                        <InputLabel>Course</InputLabel>
                        <Select
                          value={filters.courseName}
                          label="Course"
                          onChange={(e) => handleFilterChange("courseName", e.target.value)}
                        >
                          <MenuItem value="">All Courses</MenuItem>
                          {filterValues.courseNames.map((course) => (
                            <MenuItem key={course} value={course}>{course}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    
                    <Grid item xs={12} md={2}>
                      <FormControl fullWidth size="small">
                        <InputLabel>Status</InputLabel>
                        <Select
                          value={filters.failPass}
                          label="Status"
                          onChange={(e) => handleFilterChange("failPass", e.target.value)}
                        >
                          <MenuItem value="">All Statuses</MenuItem>
                          {filterValues.failPassStatuses.map((status) => (
                            <MenuItem key={status} value={status}>{status}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    
                    <Grid item xs={12}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => fetchHistoriesWithSearch(0)}
                        disabled={loader}
                        style={{ marginRight: '8px' }}
                      >
                        {loader ? <CircularProgress size={20} /> : "Apply Filters"}
                      </Button>
                      {(searchKeyword || filters.state || filters.depot || filters.courseName || filters.failPass) && (
                        <Button
                          variant="outlined"
                          color="secondary"
                          onClick={handleClearFilters}
                          disabled={loader}
                        >
                          Clear All
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                </Paper>
              </Collapse>

              {/* Statistics Summary */}
              <Paper elevation={2} sx={{ p: 2, mb: 3 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={3}>
                    <Box sx={{ textAlign: "center", p: 1 }}>
                      <Typography variant="h4" color="primary">
                        {totalRecords}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        Total Records
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <Box sx={{ textAlign: "center", p: 1 }}>
                      <Typography variant="h4" color="success.main">
                        {filteredHistories.filter(h => h.failPass?.toLowerCase().includes("pass")).length}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        Pass
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <Box sx={{ textAlign: "center", p: 1 }}>
                      <Typography variant="h4" color="error.main">
                        {filteredHistories.filter(h => h.failPass?.toLowerCase().includes("fail")).length}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        Fail
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <Box sx={{ textAlign: "center", p: 1 }}>
                      <Typography variant="h4" color="warning.main">
                        {filteredHistories.filter(h => 
                          h.failPass?.toLowerCase().includes("pending") || 
                          h.failPass?.toLowerCase().includes("not attempted")
                        ).length}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        Pending
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Paper>

              {/* History Table */}
              <Paper sx={{ width: "100%", overflow: "hidden" }}>
                <TableContainer sx={{ maxHeight: 600 }}>
                  <Table stickyHeader size="small">
                    <TableHead>
                      <TableRow>
                        {columns.map((column) => (
                          <TableCell
                            key={column.id}
                            style={{ minWidth: column.minWidth, fontWeight: "bold", backgroundColor: "#f5f5f5" }}
                          >
                            {column.sortable ? (
                              <TableSortLabel
                                active={sortBy === column.id}
                                direction={sortBy === column.id ? sortDirection.toLowerCase() : "asc"}
                                onClick={() => handleSort(column.id)}
                              >
                                {column.label}
                              </TableSortLabel>
                            ) : (
                              column.label
                            )}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredHistories.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={columns.length} align="center">
                            <Typography variant="body1" sx={{ py: 3 }}>
                              {loader ? "Loading..." : `No training history records found`}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ) : (
                        filteredHistories.map((history, index) => {
                          const isFirstRow = index === 0 || 
                            filteredHistories[index - 1]?.studentId !== history.studentId;
                          
                          const studentRowCount = filteredHistories.filter(
                            h => h.studentId === history.studentId
                          ).length;
                          
                          return (
                            <TableRow key={history.id} hover>
                              {isFirstRow ? (
                                <TableCell rowSpan={studentRowCount}>
                                  <Typography variant="body2" fontWeight="bold">
                                    {history.serialNo || index + 1}
                                  </Typography>
                                </TableCell>
                              ) : null}
                              
                              {isFirstRow ? (
                                <TableCell rowSpan={studentRowCount}>
                                  {history.employeeId || "N/A"}
                                </TableCell>
                              ) : null}
                              
                              {isFirstRow ? (
                                <TableCell rowSpan={studentRowCount}>
                                  <Typography variant="body2" fontWeight="bold">
                                    {history.participantName || "N/A"}
                                  </Typography>
                                </TableCell>
                              ) : null}
                              
                              {isFirstRow ? (
                                <TableCell rowSpan={studentRowCount}>
                                  {history.fatherName || "N/A"}
                                </TableCell>
                              ) : null}
                              
                              <TableCell>
                                <Tooltip title={history.courseName}>
                                  <Typography variant="body2" noWrap sx={{ maxWidth: 140 }}>
                                    {history.courseName || "N/A"}
                                  </Typography>
                                </Tooltip>
                              </TableCell>
                              <TableCell>
                                <Chip
                                  label={history.preTest || "0%"}
                                  size="small"
                                  color={getProgressColor(history.preTest)}
                                />
                              </TableCell>
                              <TableCell>
                                <Chip
                                  label={history.postTest || "0%"}
                                  size="small"
                                  color={getProgressColor(history.postTest)}
                                />
                              </TableCell>
                              <TableCell>
                                <Chip
                                  label={history.practicalGrade || "N/A"}
                                  size="small"
                                  variant="outlined"
                                />
                              </TableCell>
                              <TableCell>{getStatusChip(history.failPass)}</TableCell>
                              <TableCell>
                                <Typography variant="body2" noWrap sx={{ maxWidth: 100 }}>
                                  {history.remarks || "N/A"}
                                </Typography>
                              </TableCell>
                              
                              {isFirstRow ? (
                                <TableCell rowSpan={studentRowCount}>
                                  <Box display="flex" flexDirection="column" gap={0.5}>
                                    <Tooltip title="View Details">
                                      <IconButton
                                        size="small"
                                        color="primary"
                                        onClick={() => handleViewDetail(history)}
                                      >
                                        <VisibilityIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Delete All for Student">
                                      <IconButton
                                        size="small"
                                        color="error"
                                        onClick={() => {
                                          if (window.confirm(`Delete all histories for ${history.participantName}?`)) {
                                            handleDeleteAllForStudent(history.studentId);
                                          }
                                        }}
                                      >
                                        <DeleteIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                  </Box>
                                </TableCell>
                              ) : null}
                            </TableRow>
                          );
                        })
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
                
                <TablePagination
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  component="div"
                  count={totalRecords}
                  rowsPerPage={pageSize}
                  page={currentPage}
                  onPageChange={handlePageChange}
                  onRowsPerPageChange={handlePageSizeChange}
                />
              </Paper>
            </CardBody>
          </Card>
        </Col>
      </Row>

      {/* ============================
          SDR REPORT MODAL
          ============================ */}
      <Dialog
        open={reportModalOpen}
        onClose={handleCloseReportModal}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">
              <DownloadIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
              Generate SDR Report
            </Typography>
            <IconButton onClick={handleCloseReportModal}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          {/* Report Type Selection */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" gutterBottom>
              Select Report Type
            </Typography>
            <ToggleButtonGroup
              value={reportType}
              exclusive
              onChange={handleReportTypeChange}
              aria-label="report type"
              size="small"
            >
              <ToggleButton value="all" aria-label="all students">
                <PeopleIcon sx={{ mr: 1, fontSize: 20 }} />
                All Students (With History)
              </ToggleButton>
              <ToggleButton value="never-enrolled" aria-label="never enrolled">
                <PersonOffIcon sx={{ mr: 1, fontSize: 20 }} />
                Never Enrolled
              </ToggleButton>
            </ToggleButtonGroup>
            
            <Box sx={{ mt: 1 }}>
              {reportType === "all" ? (
                <Chip 
                  icon={<InfoIcon />} 
                  label="Shows all students with their training history. Same S.No. for same student across multiple courses."
                  color="info"
                  variant="outlined"
                  size="small"
                  sx={{ width: '100%', justifyContent: 'flex-start' }}
                />
              ) : (
                <Chip 
                  icon={<InfoIcon />} 
                  label="Shows students who are not enrolled in any batch. Includes basic student information."
                  color="warning"
                  variant="outlined"
                  size="small"
                  sx={{ width: '100%', justifyContent: 'flex-start' }}
                />
              )}
            </Box>
          </Box>

          {/* Report Filters */}
          <Typography variant="subtitle2" gutterBottom>
            Filters
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                size="small"
                label="Search"
                value={reportFilters.search}
                onChange={(e) => handleReportFilterChange("search", e.target.value)}
                placeholder="Name, Phone, Aadhaar..."
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            
            {reportType === "all" && (
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  size="small"
                  label="Batch ID"
                  type="number"
                  value={reportFilters.batchId}
                  onChange={(e) => handleReportFilterChange("batchId", e.target.value)}
                  placeholder="Enter batch ID"
                />
              </Grid>
            )}
            
            <Grid item xs={12} md={4}>
              <FormControl fullWidth size="small">
                <InputLabel>State</InputLabel>
                <Select
                  value={reportFilters.state}
                  label="State"
                  onChange={(e) => handleReportFilterChange("state", e.target.value)}
                >
                  <MenuItem value="">All States</MenuItem>
                  {reportFilterOptions.states.map((state) => (
                    <MenuItem key={state} value={state}>{state}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            
            <Grid item xs={12} md={4}>
              <FormControl fullWidth size="small">
                <InputLabel>Depot</InputLabel>
                <Select
                  value={reportFilters.depot}
                  label="Depot"
                  onChange={(e) => handleReportFilterChange("depot", e.target.value)}
                >
                  <MenuItem value="">All Depots</MenuItem>
                  {reportFilterOptions.depots.map((depot) => (
                    <MenuItem key={depot} value={depot}>{depot}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            
            {reportType === "all" && (
              <Grid item xs={12} md={4}>
                <FormControl fullWidth size="small">
                  <InputLabel>Course</InputLabel>
                  <Select
                    value={reportFilters.courseName}
                    label="Course"
                    onChange={(e) => handleReportFilterChange("courseName", e.target.value)}
                  >
                    <MenuItem value="">All Courses</MenuItem>
                    {reportFilterOptions.courses.map((course) => (
                      <MenuItem key={course} value={course}>{course}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}
          </Grid>

          {/* Info Box */}
          <Box sx={{ mt: 3, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
            <Typography variant="caption" color="textSecondary">
              <strong>Note:</strong> The SDR Report is optimized for large datasets (50K+ records).
              {reportType === "all" ? (
                " Each student gets a unique serial number that remains the same across all their course rows."
              ) : (
                " Shows students who are not enrolled in any batch."
              )}
            </Typography>
          </Box>
          
          {/* Loading indicator for filter options */}
          {loadingFilterOptions && (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
              <CircularProgress size={24} />
              <Typography variant="caption" sx={{ ml: 1 }}>
                Loading filter options...
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseReportModal} color="secondary">
            Cancel
          </Button>
          <Button 
            onClick={handleGenerateReport} 
            color="warning"
            disabled={reportLoading}
            variant="contained"
          >
            {reportLoading ? (
              <>
                <CircularProgress size={20} sx={{ mr: 1 }} />
                Generating...
              </>
            ) : (
              <>
                <DownloadIcon sx={{ mr: 1 }} />
                Generate Report
              </>
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Detail View Dialog */}
      <Dialog
        open={detailDialogOpen}
        onClose={() => setDetailDialogOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Training History Details</Typography>
            <IconButton onClick={() => setDetailDialogOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          {selectedDetail && (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="subtitle1" color="primary" gutterBottom>
                  Candidate Information
                </Typography>
                <Paper variant="outlined" sx={{ p: 2 }}>
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <Typography variant="body2"><strong>Name:</strong> {selectedDetail.participantName || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2"><strong>Employee ID:</strong> {selectedDetail.employeeId || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2"><strong>Father Name:</strong> {selectedDetail.fatherName || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2"><strong>Phone:</strong> {selectedDetail.phoneNumber || "N/A"}</Typography>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subtitle1" color="primary" gutterBottom>
                  Training Details
                </Typography>
                <Paper variant="outlined" sx={{ p: 2 }}>
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <Typography variant="body2"><strong>Course:</strong> {selectedDetail.courseName || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2"><strong>Depot:</strong> {selectedDetail.depot || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2"><strong>State:</strong> {selectedDetail.state || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2"><strong>Training Mode:</strong> {selectedDetail.trainingMode || "N/A"}</Typography>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subtitle1" color="primary" gutterBottom>
                  Results
                </Typography>
                <Paper variant="outlined" sx={{ p: 2 }}>
                  <Grid container spacing={1}>
                    <Grid item xs={4}>
                      <Typography variant="body2"><strong>Pre Test:</strong> {selectedDetail.preTest || "0%"}</Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="body2"><strong>Post Test:</strong> {selectedDetail.postTest || "0%"}</Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="body2"><strong>Practical Grade:</strong> {selectedDetail.practicalGrade || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2"><strong>Status:</strong> {getStatusChip(selectedDetail.failPass)}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2"><strong>Remarks:</strong> {selectedDetail.remarks || "N/A"}</Typography>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDetailDialogOpen(false)} color="secondary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete this training history?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleDeleteHistory} color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

// ============================
// MAP STATE TO PROPS
// ============================
const mapStateToProps = (state) => {
  return {
    auth: state.auth || state.login || state,
  };
};

export default connect(mapStateToProps, { setBreadcrumbItems })(StudentTrainingHistory);